import { StyleSheet, Font } from "@react-pdf/renderer";

// Font file paths
// Note: for some reason the fonts only register when the source is in a variable like this.
// it does not work when the source directory is directly typed into the Font.register() function.
import notoFont from "../fonts/NotoSans-VariableFont_wdth,wght.ttf";
import arabicFont from "../fonts/NotoSansArabic-VariableFont_wdth,wght.ttf";
import SCFont from "../fonts/NotoSansSC-VariableFont_wght.ttf";
import TCFont from "../fonts/NotoSansTC-VariableFont_wght.ttf";
import JPFont from "../fonts/NotoSansJP-VariableFont_wght.ttf";
import myanmarFont from "../fonts/NotoSansMyanmar-Regular.ttf";
import hebrewFont from "../fonts/NotoSansHebrew-VariableFont_wdth,wght.ttf";
import koreanFont from "../fonts/NotoSansKR-VariableFont_wght.ttf";
import laoFont from "../fonts/NotoSansLao-VariableFont_wdth,wght.ttf";
import thaiFont from "../fonts/NotoSansThai-VariableFont_wdth,wght.ttf";
import KNFont from "../fonts/NotoSansKannada-VariableFont_wdth,wght.ttf";
import georgianFont from "../fonts/NotoSansGeorgian-VariableFont_wdth,wght.ttf";
import MLFont from "../fonts/Chilanka-Regular.ttf";
import punjabiFont from "../fonts/TiroGurmukhi-Regular.ttf";
import tibetanFont from "../fonts/NotoSerifTibetan-VariableFont_wght.ttf";
import bengaliFont from "../fonts/NotoSansBengali-VariableFont_wdth,wght.ttf";
import dhivehiFont from "../fonts/NotoSansThaana-VariableFont_wght.ttf";
import gujaratiFont from "../fonts/NotoSansGujarati-VariableFont_wdth,wght.ttf";
import inuktutFont from "../fonts/NotoSansCanadianAboriginal-VariableFont_wght.ttf";
import khmerFont from "../fonts/NotoSansKhmer-VariableFont_wdth,wght.ttf";
import oriyaFont from "../fonts/NotoSansOriya-VariableFont_wdth,wght.ttf";
import santaliFont from "../fonts/NotoSansOlChiki-VariableFont_wght.ttf";
import sindhiFont from "../fonts/NotoSansKhudawadi-Regular.ttf";
import sinhalaFont from "../fonts/NotoSansSinhala-VariableFont_wdth,wght.ttf";
import tamazightFont from "../fonts/NotoSansTifinagh-Regular.ttf";
import tamilFont from "../fonts/NotoSansTamil-VariableFont_wdth,wght.ttf";
import teluguFont from "../fonts/NotoSansTelugu-VariableFont_wdth,wght.ttf";
import tigrinyaFont from "../fonts/NotoSansEthiopic-VariableFont_wdth,wght.ttf";

export function FontStyles () {

    // Current Progress on language implementation:
    // These only inlcude the languages that are not already covered by default Noto Sans
    //
    // ! Languages that are implemented and work:
    // Arabic
    // Baluchi
    // Cantonese
    // Simplified Chinese
    // Traditional Chinese
    // Japanese
    // Korean
    // Myanmar Burmese
    // Shan
    // Punjabi Shahmukhi
    // Dhivehi
    // Gujarati
    // Inuktut
    // Odia Oriya
    // Santalu Ol Chiki
    // Sindhi
    // Sinhala
    // Tamazight (Tifinagh)
    // Tamil
    // Telugu
    // Tigrinya
    // Urdu
    // Hebrew
    // Pashto
    // Malay Jawi
    // Yiddish
    // Persian
    // Lao
    // Thai
    // Kannada
    // Tulu
    // Georgian
    // Malayalam
    // Punjabi
    // Tibetan
    // Dzongkha
    //
    // ! Languages that don't work:
    // Kurdish Sorani (No font?)
    // Meiteilon Manipuri (No font?)
    // Khmer: Cannot create PDF; getAnchor issue; Likely needs a different font that supports Khmer
    // Tamazight (Latin version): Random character issue
    
    // This was how the default fonts (that don't support non-latin languages) were registered
    // Kept here in case something with the new registration breaks but can be deleted once the new system fully works
    /*Font.register({
      //family: 'Lato',
      family: 'Noto Sans',
      fonts: [
        {
          src: 'https://fonts.gstatic.com/s/lato/v11/iX_QxBBZLhNj5JHlTzHQzg.ttf',
          fontWeight: 700, // Lato Bold
        },
        {
          src: 'https://fonts.gstatic.com/s/lato/v11/h7rISIcQapZBpei-sXwIwg.ttf',
          fontWeight: 400, // Lato Regular
        },
        {
          src: 'http://fonts.gstatic.com/s/amiri/v7/ATARrPmSew75SlpOw2YABQ.ttf',
          fontWeight: 400,
        }
        {
          src: './frontend/src/fonts/NotoSans-VariableFont_wdth,wght.ttf',
          fontWeight: 400,
        }
      ],
    });
    */

    // Latin-based fonts as well as many non-Latin languages
    Font.register({
        family: "Noto Sans",
        format: "truetype",
        src: notoFont,
    });
    
    // Below are the Font registrations for compatiability with languages that are not supported by the Noto Sans font
    // Also yes, for some reason, they all do have to be registered seperately because they are seperate font families
    // There may be some way to register them in a cleaner way but this is the only way I found that it works
    
    // Arabic
    Font.register({
      family: "Noto Sans Arabic",
      format: "truetype",
      src: arabicFont
    });
    
    // Simplified Chinese
    Font.register({
      family: "Noto Sans SC",
      format: "truetype",
      src: SCFont
    });
    
    // Traditional Chinese
    Font.register({
      family: "Noto Sans TC",
      format: "truetype",
      src: TCFont
    });
    
    // Japanese
    Font.register({
      family: "Noto Sans JP",
      format: "truetype",
      src: JPFont
    });
    
    // Myanmar/Burmese/Shan
    Font.register({
      family: "Noto Sans Myanmar",
      format: "truetype",
      src: myanmarFont
    });
    
    // Hebrew
    Font.register({
      family: "Noto Sans Hebrew",
      format: "truetype",
      src: hebrewFont
    });
    
    // Korean
    Font.register({
      family: "Noto Sans KR",
      format: "truetype",
      src: koreanFont
    });
    
    // Lao
    Font.register({
      family: "Noto Sans Lao",
      format: "truetype",
      src: laoFont
    });
    
    // Thai
    Font.register({
      family: "Noto Sans Thai",
      format: "truetype",
      src: thaiFont
    });
    
    // Kannada
    Font.register({
      family: "Noto Sans Kannada",
      format: "truetype",
      src: KNFont
    });
    
    // Georgian
    Font.register({
      family: "Noto Sans Georgian",
      format: "truetype",
      src: georgianFont
    });
    
    // Malayalam
    Font.register({
      family: "Chilanka",
      format: "truetype",
      src: MLFont
    });
    
    // Punjabi (non-Arabic)
    Font.register({
      family: "Tiro Gurmukhi",
      format: "truetype",
      src: punjabiFont
    });
    
    // Tibetan
    Font.register({
      family: "Noto Serif Tibetan",
      format: "truetype",
      src: tibetanFont
    });
    
    // Bengali/Assamese
    Font.register({
      family: "Noto Sans Bengali",
      format: "truetype",
      src: bengaliFont
    });
    
    // Dhivehi
    Font.register({
      family: "Noto Sans Thaana",
      format: "truetype",
      src: dhivehiFont
    });
    
    // Gujarati
    Font.register({
      family: "Noto Sans Gujarati",
      format: "truetype",
      src: gujaratiFont
    });
    
    // Inuktut
    Font.register({
      family: "Noto Sans Canadian Aboriginal",
      format: "tryetype",
      src: inuktutFont
    });
    
    // Khmer
    Font.register({
      family: "Noto Sans Khmer",
      format: "truetype",
      src: khmerFont
    });
    
    // Oriya
    Font.register({
      family: "Noto Sans Oriya",
      format: "truetype",
      src: oriyaFont
    });
    
    // Santali
    Font.register({
      family: "Noto Sans Ol Chiki",
      format: "truetype",
      src: santaliFont
    });
    
    // Sindhi
    Font.register({
      family: "Noto Sans Khudawadi",
      format: "truetype",
      src: sindhiFont
    });
    
    // Sinhala
    Font.register({
      family: "Noto Sans Sinhala",
      format: "truetype",
      src: sinhalaFont
    });
    
    // Tamazight
    Font.register({
      family: "Noto Sans Tifinagh",
      format: "truetype",
      src: tamazightFont
    });
    
    // Tamil
    Font.register({
      family: "Noto Sans Tamil",
      format: "truetype",
      src: tamilFont
    });
    
    // Telugu
    Font.register({
      family: "Noto Sans Telugu",
      format: "truetype",
      src: teluguFont
    });
    
    // Tigrinya
    Font.register({
      family: "Noto Sans Ethiopic",
      format: "truetype",
      src: tigrinyaFont
    });

    const styles = StyleSheet.create({
        page: {
            padding: 15,
            fontSize: 11,
            fontFamily: "Noto Sans",
            flexDirection: "column",
        },
        // Styles for non-latin language compatability
        // These are selected based on the page's translated language
        arabicpage: {   // Arabic
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Arabic',
            flexDirection: 'column',
        },
        scpage: {       // Simplified Chinese
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans SC',
            flexDirection: 'column',
        },
        tcpage: {       // Traditional Chinese
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans TC',
            flexDirection: 'column',
        },
        jppage: {       // Japanese
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans JP',
            flexDirection: 'column',
        },
        mypage: {       // Myanmar
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Myanmar',
            flexDirection: 'column',
        },
        hepage: {       // Hebrew
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Hebrew',
            flexFirection: 'column',
        },
        kepage: {       // Korean
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans KR',
            flexDirection: 'column',
        },
        laoPage: {      // Lao
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Lao',
            flexDirection: 'column',
        },
        thaiPage: {     // Thai
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Thai',
            flexDirection: 'column',
        },
        KNPage: {       // Kannada
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Kannada',
            flexDirection: 'column',
        },
        georgianPage: { // Georgian
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Georgian',
            flexDirection: 'column',
        },
        mlpage: {       // Malayalam
            padding: 15,
            fontSize: 11,
            fontFamily: 'Chilanka',
            flexDirection: 'column',
        },
        punjabipage: {  // Punjabi (non-Arabic)
            padding: 15,
            fontSize: 11,
            fontFamily: 'Tiro Gurmukhi',
            flexDirection: 'column',
        },
        tibetanpage: {  // Tibetan
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Serif Tibetan',
            flexDirection: 'column',
        },
        bengalipage: {  // Bengali/Assamese
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Bengali',
            flexDirection: 'column',
        },
        dhivehipage: {  // Dhivehi
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Thaana',
            flexDirection: 'column',
        },
        gujaratipage: { // Gujarati
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Gujarati',
            flexDirection: 'column',
        },
        inuktutpage: {  // Inuktut
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Canadian Aboriginal',
            flexDirection: 'column',
        },
        khmerpage: {    // Khmer
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Khmer',
            flexDirection: 'column',
        },
        oriyapage: {    // Odia Oriya
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Oriya',
            flexDirection: 'column',
        },
        santalipage: {  // Santali Ol Chiki
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Ol Chiki',
            flexDirection: 'column',
        },
        sindhipage: {   // Sindhi
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Khudawadi',
            flexDirection: 'column',
        },
        sinhalapage: {  // Sinhala
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Sinhala',
            flexDirection: 'column',
        },
        tamazightpage: {  // Tamazight
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Tifinagh',
            flexDirection: 'column',
        },
        tamilpage: {      // Tamil
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Tamil',
            flexDirection: 'column',
        },
        telugupage: {     // Telugu
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Telugu',
            flexDirection: 'column',
        },
        tigrinyapage: {
            padding: 15,
            fontSize: 11,
            fontFamily: 'Noto Sans Ethiopic',
            flexDirection: 'column',
        },
        // End of non-latin language styles

        resultContainer: {
            marginBottom: 10,
            padding: 15,
            borderBottomWidth: 1,
            borderBottomColor: "#ccc",
            borderBottomStyle: "solid",
        },
        titleContainer: {
            backgroundColor: "#210062",
            padding: 5,
            marginBottom: 5,
        },
        title: {
            fontSize: 16,
            color: "white",
            textAlign: "center",
        },
        contentRow: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
        },
        content: {
            flex: 1,
            marginRight: 35,
        },
        section: {
            marginBottom: 2,
        },
        text: {
            fontWeight: 400,
            marginBottom: 10,
            marginLeft: 10,
        },
        label: {
            fontWeight: "bold",
        },
        qrCodeContainer: {
            width: 100,
            height: 100, // Make the container square
            alignItems: "center",
            justifyContent: "center",
            // Remove padding if it causes scaling issues
        },
        qrCodeImage: {
            width: 90, // Slightly smaller than the container to allow for centering
            height: 90,
            // Remove additional margins that might affect sizing
        },
    });

    return styles;
}
